import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungOffenbach() {
  return (
    <CityPageTemplate
      city="Offenbach"
      slug="offenbach"
      intro="Offenbach als Teil der Rhein-Main-Region bietet ideale Voraussetzungen für smarten Vermögensaufbau."
      description="Unabhängige & digitale Finanzberatung für Offenbach: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
